import styled from '@emotion/styled';
import React from 'react';

import { CoachNode } from 'src/generated/webapp_gql';
import { color, font } from 'src/shared/styles/variables';
import getProviderInitials from 'src/modules/videoSessions/helpers/getProviderInitials';

export const CoachAvatar = styled.img({
    width: 77,
    height: 77,
    borderRadius: '50%',
    boxShadow: '0 7px 13px 0 rgba(163, 186, 211, 0.51)',
});

export const CoachInitialsWrapper = styled(CoachAvatar.withComponent('div'))({
    backgroundColor: color.royalBlue,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const CoachInitials = styled.span(
    {
        marginTop: 5,
        color: color.white,
    },
    font.heavy(22),
);

interface Props {
    provider: Pick<CoachNode, 'avatar' | 'firstName' | 'lastName'>;
}

export const RateSessionProviderAvatar: React.FC<Props> = ({ provider }) => {
    return provider.avatar ? (
        <CoachAvatar src={provider.avatar} alt="coach avatar" />
    ) : (
        <CoachInitialsWrapper>
            <CoachInitials>{getProviderInitials(provider)}</CoachInitials>
        </CoachInitialsWrapper>
    );
};
